import React, { useState, useEffect } from "react";
import AdminTopbar from "../../component/AdminTopbar";
import { Paperclip, Send } from "react-feather"; 
import CreateChatRoom from "./CreateChatRoom";



function ChatWindow() {
  const [chatRooms, setChatRooms] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [userId, setUserId] = useState("1");

  useEffect(() => {
    const dummyRooms = [
      { id: 101, name: "Support Chat", category: "Support", reference_id: "A123" },
      { id: 102, name: "Order Chat", category: "Order", reference_id: "B456" },
      { id: 103, name: "Feedback", category: "Review", reference_id: "C789" },
    ];
    setChatRooms(dummyRooms);
  }, []);

  useEffect(() => {
  if (selectedRoom) {
    const dummyMessages = [
      {
        sender_id: "1",
        sender_name: "Admin",
        sender_avatar: "https://i.pravatar.cc/40?img=1",
        message: "Hello, how can I help you?",
        created_at: new Date(),
        attachment: null,
      },
      {
        sender_id: "2",
        sender_name: "Customer",
        sender_avatar: "https://i.pravatar.cc/40?img=2",
        message: "I have an issue with my order.",
        created_at: new Date(),
        attachment: null,
      },
      {
        sender_id: "1",
        sender_name: "Admin",
        sender_avatar: "https://i.pravatar.cc/40?img=1",
        message: "Please share the order ID.",
        created_at: new Date(),
        attachment: null,
      },
    ];
    setMessages(dummyMessages);
  }
}, [selectedRoom]);


  const handleSendMessage = () => {
    if (!message && !attachment) return;

    const newMsg = {
      sender_id: userId,
      message,
      attachment: attachment ? "dummy.pdf" : null,
      created_at: new Date(),
    };

    setMessages((prev) => [...prev, newMsg]);
    setMessage("");
    setAttachment(null);
  };

  return (
    <>
      <AdminTopbar />
      <div className="chat-container">
        {/* Sidebar */}
        <div className="chat-sidebar text-start">
          <h5 className="chat-title d-flex justify-content-between align-items-center">💬 Chat Rooms  <CreateChatRoom /></h5>
          {chatRooms.map((room) => (
            <div
              key={room.id}
              className={`chat-room ${selectedRoom?.id === room.id ? "active" : ""}`}
              onClick={() => setSelectedRoom(room)}
            >
              <strong>{room.name}</strong>
              <div className="chat-meta">{room.category} - #{room.reference_id}</div>
            </div>
          ))}
        </div>

        {/* Chat Window */}
        <div className="chat-main">
          {selectedRoom ? (
            <>
              <div className="chat-header">
                <h4>{selectedRoom.name}</h4>
              </div>

             <div className="chat-body">
  {messages.map((msg, idx) => {
    const isOwn = msg.sender_id === userId;
    return (
      <div key={idx} className={`chat-row ${isOwn ? "own" : "other"}`}>
        <img src={msg.sender_avatar} alt="avatar" className="avatarchat" />
        <div className="chat-bubble">
          <div className="bubble-content">
            {!isOwn && <div className="sender-name">{msg.sender_name}</div>}
            {msg.message && <div>{msg.message}</div>}
            {msg.attachment && (
              <a href="#" onClick={(e) => e.preventDefault()} className="attachment-link">
                📎 Dummy Attachment
              </a>
            )}
            <div className="timestamp">{new Date(msg.created_at).toLocaleString()}</div>
          </div>
        </div>
      </div>
    );
  })}
</div>




              <div className="chat-input">
                <input
                  type="text"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Type a message..."
                />
                <input
                  type="file"
                  onChange={(e) => setAttachment(e.target.files[0])}
                  style={{ display: 'none' }}
                  id="fileInput"
                />
                <label htmlFor="fileInput" className="file-attach">
                  <Paperclip size={16} />
                </label>
                <button className="send-btn" onClick={handleSendMessage}>
                  <Send size={16} />
                </button>
              </div>
            </>
          ) : (
            <div className="select-room-message">🎯 Select a chat room to start messaging</div>
          )}
        </div>
      </div>
    </>
  );
}

export default ChatWindow;
